import { render, staticRenderFns } from "./StarterFormList.vue?vue&type=template&id=67028288&lang=true"
import script from "./starterformlist.js?vue&type=script&lang=js&external"
export * from "./starterformlist.js?vue&type=script&lang=js&external"
import style0 from "./StarterFormList.vue?vue&type=style&index=0&id=67028288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports